<template>
  <el-card style="width: 32%;">
    <div style="text-align:center;font-weight:bold;font-size:19px;margin-bottom:15px;">男女发薪累计</div>
    <el-row justify="space-between">
      <div ref="statisticsMale" style="height: 310px;width: 50%"></div>
      <div ref="statisticsFemale" style="height: 310px;width: 50%"></div>
    </el-row>
  </el-card>
</template>

<script>
import { defineComponent } from 'vue'

export default defineComponent({
  props: {
    statisticsData: Object
  },
  data() {
    return {
      statisticsMaleChart: null,
      statisticsFeMaleChart: null
    }
  },
  watch: {
    statisticsData: {
      handler(val) {
        this.setChart();
      },
      deep: true
    }
  },
  methods: {
    setChart() {
      if (!this.statisticsMaleChart) {
        this.statisticsMaleChart = this.$echarts.init(this.$refs.statisticsMale);
      }
      if (!this.statisticsFeMaleChart) {
        this.statisticsFeMaleChart = this.$echarts.init(this.$refs.statisticsFemale);
      }
      let statisticsData = this.statisticsData;
      if (!statisticsData) {
        return;
      }

      if (!statisticsData.maleSalary) {
        statisticsData.maleSalary = 0;
      }

      if (!statisticsData.femaleSalary) {
        statisticsData.femaleSalary = 0;
      }

      let total = statisticsData.maleSalary + statisticsData.femaleSalary;

      let detail = (statisticsData.maleSalary / 10000).toFixed(1) + '万';
      let value = statisticsData.maleSalary > 0 ? parseFloat((statisticsData.maleSalary / total * 100).toFixed(2)) : 0;
      this.statisticsMaleChart.setOption(this.getOption(this.getGaugeData(detail, value), '男性总额'));

      detail = (statisticsData.femaleSalary / 10000).toFixed(1) + '万';
      value = statisticsData.maleSalary > 0 ?  parseFloat((statisticsData.femaleSalary / total * 100).toFixed(2)) : 0;
      this.statisticsFeMaleChart.setOption(this.getOption(this.getGaugeData(detail, value), '女性总额'));
    },
    getGaugeData(detail, value) {
      return [
        {
          value: value,
          name: detail,
          title: {
            offsetCenter: ['0%', '20%']
          },
          detail: {
            valueAnimation: true,
            offsetCenter: ['0%', '-20%']
          }
        }
      ];
    },
    getOption(gaugeData, title) {
      return {
        title: {
          text: title,
          left: 'center',
          bottom: 10
        },
        series: [
          {
            type: 'gauge',
            startAngle: 90,
            endAngle: -270,
            pointer: {
              show: false
            },
            progress: {
              show: true,
              overlap: false,
              roundCap: true,
              clip: false,
              itemStyle: {
                borderWidth: 1,
                borderColor: '#2391ff',
                color: '#2391ff'
              }
            },
            axisLine: {
              lineStyle: {
                width: 10
              }
            },
            splitLine: {
              show: false,
              distance: 0,
              length: 10
            },
            axisTick: {
              show: false
            },
            axisLabel: {
              show: false,
              distance: 50
            },
            data: gaugeData,
            title: {
              fontSize: 14
            },
            detail: {
              width: 50,
              height: 14,
              fontSize: 14,
              color: 'inherit',
              borderColor: 'none',
              borderRadius: 35,
              borderWidth: 1,
              formatter: '{value}%'
            }
          }
        ]
      };
    }

  }
})
</script>
